import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query Wishlist(\n    $after: String\n    $first: Int\n    $countryCode: CountryCode\n    $languageCode: LanguageCodeEnum!\n  ) {\n    wishlist {\n      id\n      items(after: $after, first: $first) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        edges {\n          node {\n            ...WishlistItem\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { wishlistItemFragment } from "../fragments/wishlist";
export var userWishlist = gql(_templateObject(), wishlistItemFragment);